function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4139 8C17.335 8 18.2306 8.28258 18.9819 8.8047L19.2947 9.043L24.044 13H39.5C41.7734 13 43.6532 14.6859 43.957 16.8758L43.9896 17.1919L44 17.5V35.5C44 37.8818 42.1496 39.8312 39.808 39.9896L39.5 40H8.5C6.11828 40 4.16872 38.1496 4.01038 35.808L4 35.5V12.5C4 10.1183 5.85032 8.16872 8.1919 8.01038L8.5 8H16.4139ZM19.2947 19.957C18.5871 20.5466 17.7181 20.903 16.8067 20.9828L16.4139 21L7 20.998V35.5C7 36.2594 7.5643 36.887 8.29646 36.9864L8.5 37H39.5C40.2594 37 40.887 36.4356 40.9864 35.7036L41 35.5V17.5C41 16.7406 40.4356 16.113 39.7036 16.0137L39.5 16H24.042L19.2947 19.957ZM16.4139 11H8.5C7.7406 11 7.11302 11.5643 7.0137 12.2965L7 12.5V17.998L16.4139 18C16.6946 18 16.9682 17.9213 17.2044 17.7748L17.3741 17.6523L21.156 14.498L17.3741 11.3477C17.1585 11.168 16.8979 11.0533 16.6226 11.0146L16.4139 11Z",
  fill: "#D8D8D8"
});

var SvgIcFolder = function SvgIcFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_folder.885a7bad.svg";
export { ForwardRef as ReactComponent };